import { atom } from "recoil";
export const companyDetailsState = atom({
    key: "companyDetailsState",
    default: "",
});
